import {
  fetchRefillCollection,
  fetchPrefillCollection,
} from "./helpers/graphql/requests";

class ProductCompare extends HTMLElement {
  constructor() {
    super();
    this.endpoint =
      "https://vapesupertore1.myshopify.com/api/2025-04/graphql.json";
    this.publicToken = "07509e17a73d6fdb640c448a8cc2372a";
    this.products = [];
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.selectA = this.querySelector('[data-select="product-one"]');
      this.selectB = this.querySelector('[data-select="product-two"]');

      if (!this.selectA || !this.selectB) {
        console.warn("Select elements not found inside <product-compare>");
        return;
      }

      this.fetchProducts();

      window.addEventListener("resize", () => {
        this.disableSelectedOption(this.selectA, this.selectB);
        this.disableSelectedOption(this.selectB, this.selectA);
      });
    });
  }

  async fetchProducts() {
    try {
      let products;

      const _type = this.getAttribute("data-type");

      if (_type == "prefill") {
        const prefillProducts = await fetchPrefillCollection({
          endpoint: this.endpoint,
          token: this.publicToken,
        });

        products = prefillProducts;
      } else {
        const refillProducts = await fetchRefillCollection({
          endpoint: this.endpoint,
          token: this.publicToken,
        });

        products = refillProducts;
      }

      if (!Array.isArray(products)) return;

      this.products = products;

      this.populateSelect(this.selectA, products);
      this.populateSelect(this.selectB, products);

      const defaultProductOneID = this.getAttribute("data-product-one");
      const defaultProductTwoID = this.getAttribute("data-product-two");

      if (defaultProductOneID) this.selectA.value = defaultProductOneID;
      if (defaultProductTwoID) this.selectB.value = defaultProductTwoID;

      this.disableSelectedOption(this.selectA, this.selectB);
      this.disableSelectedOption(this.selectB, this.selectA);

      this.selectA.addEventListener("change", () => {
        this.disableSelectedOption(this.selectA, this.selectB);
        this.onSelectChange(this.selectA.value, "one");
      });

      this.selectB.addEventListener("change", () => {
        this.disableSelectedOption(this.selectB, this.selectA);
        this.onSelectChange(this.selectB.value, "two");
      });
    } catch (err) {
      console.error("Error fetching products:", err);
    }
  }

  populateSelect(select, products) {
    if (!select) return;

    select.innerHTML = "";

    const currentProductID = this.dataset.currentProduct;

    const sortedProducts = [...products].sort((a, b) =>
      a.title.localeCompare(b.title, undefined, {sensitivity: "base"}),
    );

    sortedProducts.forEach((product) => {
      if (product.id === currentProductID) return;

      const option = document.createElement("option");
      option.value = product.id;
      option.textContent = product.title;
      select.appendChild(option);
    });
  }

  disableSelectedOption(activeSelect, otherSelect) {
    if (!activeSelect || !otherSelect) return;

    const selectedValue = activeSelect.value;

    if (window.innerWidth < 1024) {
      [...otherSelect.options].forEach((opt) => (opt.disabled = false));
      return;
    }

    [...otherSelect.options].forEach((opt) => (opt.disabled = false));

    if (selectedValue) {
      const match = [...otherSelect.options].find(
        (opt) => opt.value === selectedValue,
      );
      if (match) match.disabled = true;
    }
  }

  onSelectChange(selectedID, selectNumber) {
    if (!this.products) return;

    const selectedProduct = this.products.find((p) => p.id === selectedID);
    this.handleProductSelection(selectedProduct, selectedID, selectNumber);
  }

  async handleProductSelection(product, id, selectNumber) {
    if (!product) return;

    const {specs} = product;
    const {fields = []} = specs?.reference || [];

    const productRating = await fetch(
      `/products/${product?.handle}?section_id=compare-rating`,
    );
    const res = await productRating.text();

    let p = new DOMParser();
    let doc = p.parseFromString(res, "text/html");
    let rating = doc.querySelector("#shopify-section-compare-rating > div");

    // Determine which column to update
    const columnIndex = selectNumber === "one" ? 0 : 1;

    // Root table inside this custom element
    const tableRoot = this.querySelector("product-compare-table");
    if (!tableRoot) return;

    // Update mobile titles
    const dynamicTitlesMobile = tableRoot.querySelectorAll(
      '.stat[data-kind="title-mobile"] .dynamic-value',
    );
    if (dynamicTitlesMobile?.[columnIndex]) {
      dynamicTitlesMobile[columnIndex].innerHTML = `${product.title}`;
    }

    // Update Images
    const dynamicImages = tableRoot.querySelectorAll(
      '.images[data-kind="images"] .dynamic-value',
    );
    if (dynamicImages?.[columnIndex]) {
      dynamicImages[columnIndex].innerHTML = `
        <img src="${product.featuredImage?.url || ""}" alt="${product.title || ""}" />
      `;
    }

    // Update Price
    const dynamicPrices = tableRoot.querySelectorAll(
      '.stat[data-kind="price"] .dynamic-value',
    );
    if (dynamicPrices?.[columnIndex]) {
      dynamicPrices[columnIndex].innerHTML = `
        <span class="money">£${product.priceRange?.minVariantPrice?.amount || "-"}</span>
      `;
    }

    // update rating - s
    const dynamicRating = tableRoot.querySelectorAll(
      '.stat[data-kind="rating"] .dynamic-value',
    );
    if (dynamicRating?.[columnIndex]) {
      dynamicRating[columnIndex].innerHTML = rating.outerHTML;
    }

    // Update Specs
    const allSpecRows = tableRoot.querySelectorAll('.stat[data-kind^="spec_"]');
    const specFields = fields.filter((f) => f.key.startsWith("spec_"));

    allSpecRows.forEach((statEl) => {
      const dynamicValues = statEl.querySelectorAll(".dynamic-value");
      if (!dynamicValues?.[columnIndex]) return;

      const key = statEl.getAttribute("data-kind");
      const field = specFields.find((f) => f.key === key);

      let value = "-";
      if (field) {
        value = field.value || "-";

        try {
          const parsed = JSON.parse(value);
          if (Array.isArray(parsed)) value = parsed.join(", ");
        } catch (e) {}
      }

      dynamicValues[columnIndex].innerHTML = value;
    });

    // Update Link
    const dynamicLinks = tableRoot.querySelectorAll(
      '.stat[data-kind="link"] .dynamic-value',
    );
    if (dynamicLinks?.[columnIndex]) {
      dynamicLinks[columnIndex].innerHTML = `
        <a href="/products/${product.handle || ""}">
          <div class="button button--primary">View</div>
        </a>
      `;
    }
  }
}

customElements.define("product-compare", ProductCompare);
